import Cookies from 'js-cookie'

import type { LoginResData } from '~/types/auth'

const saveTokens = (tokens: LoginResData) => {
  const { access_token, refresh_token, exp } = tokens

  Cookies.set('access_token', access_token, { sameSite: 'Lax', secure: true })
  Cookies.set('refresh_token', refresh_token, { sameSite: 'Lax', secure: true })
  Cookies.set('exp', exp, { sameSite: 'Lax', secure: true })
}
const removeTokens = () => {
  Cookies.remove('access_token')
  Cookies.remove('refresh_token')
  Cookies.remove('exp')
}
const getAccessToken = () => Cookies.get('access_token')
const getRefreshToken = () => Cookies.get('refresh_token')
const getExpToken = () => Cookies.get('exp')

export { getAccessToken, getExpToken, getRefreshToken, removeTokens, saveTokens }
